<template>
    <div class="row m-4 justify-content-center onboarding-new align-items-stretch wiland-onboarding">
        <div class="col-lg-6 col-12">
            <div class="row h-100 justify-content-center align-items-center flex-grow-1">
                <div class="registration-form-container col-lg-8 col-12 mt-5 mt-lg-0 d-flex flex-column justify-content-center align-items-stretch ">
                    <div  class="d-flex cobrand-logo-container align-items-center justify-content-center w-100 my-4">
                        <a class="navbar-brand" href="/">
                            <img src="/img/logo_png/avid_logo_red.png" alt="Avid" class="navbar-brand-logo px-2">
                        </a>
                        <div class="mx-3 d-flex justify-content-center align-items-center"><span class="h1 mb-0 text-primary fw-normal">&</span></div>
                        <a class="navbar-brand" href="https://www.wiland.com" target="_blank">
                            <img src="/img/logo_png/wiland_logo.svg" alt="Wiland" class="navbar-brand-logo px-2">
                        </a>
                    </div>

                    <h2 class="text-center my-3">Create an Account</h2>
                    <div class="row">
                        <nav class="navbar navbar-expand secondary-tab-bar border-0 w-100 mb-4 pb-0">
                            <div class="container-fluid">  
                                <div class="collapse navbar-collapse">
                                    <div class="btn-group toggle-btn-group w-100 gap-1" role="group">
                                        <button type="button" class="btn btn-lg w-50 h-100" :class="(local_org.type == 'nonprofit')?'btn-primary':'btn-secondary'" @click="onOrgTypeChange('nonprofit')">
                                            I Work at a Nonprofit
                                        </button>
                                        <button type="button" class="btn btn-lg w-50 h-100" :class="(local_org.type == 'agency')?'btn-primary':'btn-secondary'" @click="onOrgTypeChange('agency')">
                                            I Work with Nonprofits
                                        </button>
                                    </div>
                                </div>                    
                            </div>
                        </nav>
                    </div>

                    <div class="row mb-3">
                        <div class="col-12" v-if="local_org.type == 'nonprofit'">
                            <div class="client-select-container dropdown d-flex w-100">
                              <a class="dropdown-toggle client-select-toggle d-flex align-items-center justify-content-between px-2 w-100" :class="{ 'is-open': isOrgDropdownOpen, 'is-invalid': errors.org_name != '' }" href="#" data-bs-toggle="dropdown" @click.prevent.stop="handleOrgToggleClick">
                                <div class="d-flex align-items-center w-100 position-relative">
                                  <div class="d-flex align-items-center w-100">
                                    <template v-if="!isOrgDropdownOpen">
                                      <span class="flex-grow-1 text-truncate ps-3" :class="local_org && local_org.name ? '': 'text-color-muted'">
                                        {{ local_org && local_org.name ? local_org.name : 'Nonprofit Name *  (Type to Search)' }}
                                        </span>
                                    </template>
                                    <template v-else>
                                      <span class="toggle-search-icon"><i class="fa fa-search"></i></span>
                                      <input ref="orgToggleSearchInput" type="text" class="form-control toggle-search-input w-100" :placeholder="local_org && local_org.name ? local_org.name : 'Search by Name...'" v-model="orgSearchKey" @input="onOrgSearchInput" @keydown.enter.prevent="selectFirstVisibleOrg" @click.stop aria-label="local_org && local_org.name ? local_org.name :">
                                    </template>
                                  </div>
                                  <div class="chevron-icon-container">
                                    <span class="chevron-inner">
                                      <i class="fa fa-chevron-down chevron-icon m-0 p-0" :class="{ rotated: isOrgDropdownOpen }"></i>
                                    </span>
                                  </div>
                                </div>
                              </a>

                              <div class="dropdown-menu dropdown-menu-primary pt-0 w-100" id="org-search-dropdown-menu" data-bs-popper="none">
                                <div class="options-container">
                                  <template v-if="orgSearchKey && orgSearchKey.trim() !== ''">
                                    <a href="#" class="dropdown-item py-0 my-3 px-1 d-flex align-items-center " @click.prevent="addNewOrg(orgSearchKey)">
                                      <i class="fas fa-plus me-2"></i>
                                      <span>Add Organization as Written</span>
                                    </a>
                                    <hr></hr>
                                  </template>

                                  <template v-if="(local_org_list && local_org_list.length > 0)">
                                    <a v-for="opt in local_org_list" :key="opt.ein || opt.name" href="#" class="dropdown-item py-0 my-3 px-1 d-flex align-items-center" @click.prevent="selectOrg(opt)">
                                      <span class="text-truncate">{{ opt.label || opt.name }}</span>
                                    </a>
                                  </template>
                                  <template v-else>
                                    <div class="p-2 suboption show mt-1" v-if="!orgSearchKey || orgSearchKey.trim() === ''">
                                      <em>Type to search for your nonprofit...</em>
                                    </div>
                                    <div class="p-2 suboption show mt-1" v-else-if="searching === true">
                                      <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                    <div class="p-2 suboption show mt-1" v-else-if="search_error === true">
                                      <em>We seem to be having trouble searching for your organization; please enter the name and click "Add Organization as Written" to continue</em>
                                    </div>
                                    <div class="p-2 suboption show mt-1" v-else>
                                      <em>No organizations match your search</em>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <div class="text-danger invalid-feedback" v-if="errors.org_name != ''" v-html="errors.org_name"></div>
                        </div>

                        <div class="col-12" v-if="local_org.type == 'agency'">
                            <input type="text" class="form-control" :class="((errors.org_name != '' )? 'is-invalid':'')"
                                name="name" placeholder="Company Name *" v-model="local_org.name" @change="errors.org_name = ''" aria-label="Company Name *">
                            <div class="text-danger invalid-feedback" v-if="errors.org_name != ''" v-html="errors.org_name"></div>
                        </div>

                        <div class="col-12 mt-5">
                            <div class="d-flex gap-3 my-2 w-100 justify-content-center align-items-center">
                                <a :href="processing || local_org.name == '' ? '#' : '/auth/register/google'" class="btn p-0">
                                    <div :class="(processing || local_org.name == '') ? 'disabled-icon-container':'passive-blue-icon-container'">
                                        <img src="/img/images/google_icon.png" alt="Google" class="social-icon ms-1" :class="{'grayscale': processing || local_org.name == '' }">
                                    </div>
                                </a>
                        
                                <a :href="processing || local_org.name == '' ? '#' : '/auth/register/microsoft'" class="btn p-0" >
                                    <div :class="(processing || local_org.name == '') ? 'disabled-icon-container':'passive-blue-icon-container'">
                                        <img src="/img/images/microsoft_icon.png" alt="Microsoft" class="social-icon ms-1" :class="{'grayscale': processing || local_org.name == '' }">
                                    </div>
                                </a>

                                <a :href="processing || local_org.name == '' ? '#' : '/auth/register/salesforce'" class="btn p-0">
                                    <div :class="(processing || local_org.name == '') ? 'disabled-icon-container':'passive-blue-icon-container'">
                                        <img src="/img/images/salesforce_icon.png" alt="Salesforce" class="social-icon ms-1" :class="{'grayscale': processing || local_org.name == '' }">
                                    </div>
                                </a>
                            </div>

                            <div class="divider-with-text my-3">or</div>

                            <div class="onboarding-personal-info">       
                                <div class="row">
                                    <div class="mb-3 col-6">
                                        <input type="text" class="form-control" :class="((errors.first_name != '' )? 'is-invalid':'')"
                                            name="first_name" placeholder="First Name" v-model="local_user.first_name" @change="errors.first_name = ''" aria-label="First Name">
                                        <div class="text-danger invalid-feedback" v-if="errors.first_name != ''">
                                            {{errors.first_name}}
                                        </div>
                                    </div>
                                    <div class="mb-3 col-6">
                                        <input type="text" class="form-control" :class="((errors.last_name != '' )? 'is-invalid':'')"
                                            name="last_name" placeholder="Last Name" v-model="local_user.last_name"  @change="errors.last_name = ''" aria-label="Last Name">
                                        <div class="text-danger invalid-feedback" v-if="errors.last_name != ''">
                                            {{errors.last_name}}
                                        </div>
                                    </div>
                                    <div class="mb-3 col-12">
                                        <input type="text" class="form-control" :class="((errors.email != '' )? 'is-invalid':'')"
                                            name="email" placeholder="Email" v-model="local_user.email" @change="validateEmail()" aria-label="Email">
                                        <div class="text-danger invalid-feedback" v-if="errors.email != ''" v-html='errors.email'></div>
                                    </div>
                                    <div class="mb-4 col-12">
                                        <password-visibility
                                            :model-value="local_user.password.value"
                                            @update:modelValue="val => { local_user.password.value = val; }"
                                            name="password"
                                            placeholder="Password"
                                            :required="true"
                                            autocomplete="one-time-code"
                                            :has-error="errors.password != ''"
                                            :show-inline-error="false"
                                            @change="validatePassword()"
                                        />
                                        <div class="text-danger invalid-feedback d-block" v-if="errors.password != ''">
                                            <span v-html="errors.password"></span><br>
                                            <em class="small">(Password must be at least 8 characters long, complex enough to be hard to guess, and avoid common patterns and sequences)</em>
                                        </div>
                                    </div>
                
                                    <div class="col-12 m-2">
                                        <label :class="errors.terms_and_conditions != '' ? 'text-danger' : ''">
                                            <input type="checkbox" name="terms_and_conditions" id="terms_and_conditions" v-model="terms_and_conditions" class="form-check-input"  aria-label="Terms And Conditions">
                                            <span class="ms-2">By signing up, I agree to Avid's <a href="/privacy_policy">privacy policy</a>, <a href="/terms_and_conditions">the terms of service</a> and <a href="/fulfillment_policy">the fulfillment policy</a> .</span>
                                        </label>
                                        <div class="text-danger invalid-feedback" v-if="errors.terms_and_conditions != ''">
                                            {{errors.terms_and_conditions}}
                                        </div>
                                    </div>

                                    <div class="col-12 my-3">
                                        <button type="submit" class="btn btn-primary w-100 mt-2" @click="createAccount()"
                                            :disabled="processing || local_user.first_name == '' || local_user.last_name == '' || local_user.email == '' || local_user.password.value == ''">
                                            <span v-if="processing">
                                                <div class="spinner-border  spinner-border-sm text-white float-left" role="status"></div>Processing
                                            </span>
                                            <span v-else>Create an Account</span>
                                        </button>
                                    </div>

                                    <div class="mb-3 col-12">
                                        <p>Already have one?
                                            <a class="btn btn-link ps-0" href="/login">
                                                Log In
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <hr class="mb-5">
                    <div class="row mb-3">
                        <div class="col">
                            <div class="d-flex align-items-center mb-3">
                                <img src="/img/lock.png" alt="lock" class="me-3" style="width:64px;">
                                <div>
                                    <h4 class="mb-2">Your Data is Secure</h4>
                                    <p class="mb-0">Avid takes the security of your data seriously.
                                    <a href="https://trust.avidai.com" target="_blank">Visit our trust center</a>
                                    to see our SOC2 compliance status and the steps taken to ensure your organization's privacy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 d-none d-lg-block bg-with-image p-5">  
            <div class="row mb-4">     
                <h2 class="mb-2">Fundraising benchmarks, rebuilt for how fundraising actually works.</h2>
                <p class="mb-3">Monthly-updated benchmarks from more than 1,000 nonprofits, powered by Avid and Wiland.</p>
            </div>

            <div class="row text-container mb-4 align-items-center">
                <div class="col-8">
                    <h3 class="mb-2">Monthly clarity, while decisions still matter</h3>
                    <p class="mb-0">See how donor behavior is shifting across the sector: what’s steady, what’s slipping, and where momentum is building. Real performance from peer organizations, delivered while decisions still matter.</p>
                </div>
                <div class="col-4">
                    <img src="/img/images/benchmarks-chart-1.png" class="img-fluid" style="max-width: 100%; height: auto;"></img>
                </div>
            </div>
            <div class="row text-container mb-4 align-items-center">
                <div class="col-4">
                    <img src="/img/images/benchmarks-chart-2.png" class="img-fluid" style="max-width: 100%; height: auto;"></img>
                </div>
                <div class="col-8">                    
                    <h3 class="mb-2">Depth you won’t find anywhere else</h3>
                    <p class="mb-0">See how donors move into mid- and major-giving, how upgrade patterns are changing, and where recurring giving is accelerating. Built on real donor behavior, not survey averages or static reports.</p>
                </div>
            </div>
            <div class="row text-container mb-4 align-items-center">
                <div class="col-8">
                    <em><p>What you get:</p></em>
                    <p>Full access to every benchmark, visualization, and trend, plus monthly updates delivered to your inbox.</p>
                    
                    <ul>
                        <li>Free access to every benchmark dashboard</li>
                        <li>Monthly-updated data built on real fundraising performance</li>
                        <li>Benchmarks across more than 1,000 nonprofits, with context by size and sector</li>
                    </ul>   

                    <p>This benchmark is free to access for anyone who registers and is designed to support real fundraising decisions, not just one-time comparisons.</p>
                </div>
                <div class="col-4">
                    <img src="/img/images/benchmarks-chart-3.png" class="img-fluid" style="max-width: 100%; height: auto;"></img>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import debounce from 'lodash.debounce';

export default defineComponent({
    name: 'OnboardingNew',
    props: {
        error: {
            type: Object,
            default: () => ({})
        }
    },
    components: { },
    data() {
        return {
            searched_org: true,
            debouncedSearchOptions: null,  
            local_org_list: [],                
            local_org: {
                name: '',
                type: 'nonprofit',
                ein: null,
                size: null,
                vertical: null,
                domain: null,
                fiscal_year_offset: 0,
                mission: null
            },                
            local_user: {
                first_name: '',
                last_name: '',
                email: '',
                password: {
                    value: '',
                    type: 'password',
                    visible: false
                },
            },
            errors: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                org_name: '',
                terms_and_conditions: '',
            },
            form: {
                error: false,
            },
            searching: false,
            search_error: false,
            terms_and_conditions: false,
            processing: false,
            // org dropdown UI state
            isOrgDropdownOpen: false,
            orgSearchKey: '',
        };
    },
    created() {
        this.debouncedSearchOptions = debounce(this.searchOptions, 1000);
    },
    beforeMount() {
        // Empty but kept for consistency
    },
    mounted() {
        // Setup org search dropdown behavior and outside click handling
        this.$nextTick(() => {
            this.setupOrgDropdownBehavior();
        });
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOrgDocumentClick, true);
        if (this._outsideClickHandler) document.removeEventListener('click', this._outsideClickHandler, true);
    },
    // For Vue 3 compatibility
    beforeUnmount() {
        document.removeEventListener('click', this.handleOrgDocumentClick, true);
        if (this._outsideClickHandler) document.removeEventListener('click', this._outsideClickHandler, true);
    },
    methods: {
        onOrgSearchInput() {
            if (this.orgSearchKey && this.orgSearchKey.trim() !== '') {
                this.debouncedSearchOptions(this.orgSearchKey.trim());
            } else {
                this.local_org_list = [];
            }
        },
        handleOrgToggleClick() {
            const toggle = this.$el.querySelector('.client-select-toggle');
            if (!toggle) return;
            let dropdownInstance = null;
            if (window && window.bootstrap && window.bootstrap.Dropdown) {
                dropdownInstance = window.bootstrap.Dropdown.getInstance(toggle) || new window.bootstrap.Dropdown(toggle);
            } else if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                dropdownInstance = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle);
            }
            if (dropdownInstance && typeof dropdownInstance.toggle === 'function') {
                dropdownInstance.toggle();
            }
            setTimeout(() => {
                if (this.isOrgDropdownOpen) this.focusOrgToggleSearch();
            }, 100);
        },
        focusOrgToggleSearch() {
            const input = this.$refs.orgToggleSearchInput;
            if (input && typeof input.focus === 'function') {
                input.focus();
            }
        },
        handleOrgDocumentClick(event) {
            // Deprecated in favor of _outsideClickHandler; keep as no-op to avoid breaking references
            return;
        },
        onOrgTypeChange(type) {
            this.local_org.type = type;
            this.local_org.name = '';
            this.orgSearchKey = '';
            this.local_org_list = [];
            const toggle = this.$el.querySelector('.client-select-toggle');
            if (toggle) {
                let dropdownInstance = null;
                if (window && window.bootstrap && window.bootstrap.Dropdown) {
                    dropdownInstance = window.bootstrap.Dropdown.getInstance(toggle);
                } else if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                    dropdownInstance = bootstrap.Dropdown.getInstance(toggle);
                }
                if (dropdownInstance && typeof dropdownInstance.dispose === 'function') {
                    dropdownInstance.dispose();
                }
            }
            this.isOrgDropdownOpen = false;
            // Re-setup dropdown behavior after changing tabs
            this.$nextTick(() => this.setupOrgDropdownBehavior());
        },
        toggleVisibility(field) {
            if (field.type === 'password') {
                field.type = 'password-text';
                field.visible = true;
            } else if (field.type === 'password-text') {
                field.type = 'password';
                field.visible = false;
            }
        },
        thirdPartyLogin(provider) {
            window.location.href = `/auth/register/${provider}`;
        },
        hasErrors() {
            //validate the form
            if(this.local_org.name == null || this.local_org.name == "") {
                this.errors.org_name = "Organization name is required.";
            } else {
                this.errors.org_name = "";
            }
             
            if(this.local_user.first_name == null || this.local_user.first_name == "") {
                this.errors.first_name = "First name is required.";
            } else {
                this.errors.first_name = "";
            }
             
            if(this.local_user.last_name == null || this.local_user.last_name == "") {
                this.errors.last_name = "Last name is required.";
            } else {
                this.errors.last_name = "";
            }

            const reg = /^\w+([\.-]?\w+)*(\+?\w+([\.-]?\w+)*)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
            if(this.local_user.email == null || this.local_user.email == "") {
                this.errors.email = "Email is required.";
            } else if(!reg.test(this.local_user.email)) {
                this.errors.email = 'Please enter a valid email address.';
            } else if (this.errors.email.indexOf('The email entered is already attached to an existing user.') != -1) {
                // Keep existing error
            } else {
                this.errors.email = "";
            }

            if(this.local_user.password.value == null || this.local_user.password.value == "") {
                this.errors.password = "Password is required.";
            } else {
                this.errors.password = "";
            }

            if(this.terms_and_conditions == false) {
                this.errors.terms_and_conditions = "You must agree to the terms of service.";
            } else {
                this.errors.terms_and_conditions = "";
            }
             
            for (const error_name in this.errors) {
                if (this.errors[error_name] != "") {
                    return true;
                }
            }
            return false; 
        },
        validateEmail() {
            window.axios.post('/api/new_user/check_email', this.local_user)
                .then(response => {
                    if(response.data.exists) {
                        this.errors.email = 'The email entered is already attached to an existing user. <a href="/login">Click here to login.</a>';
                    } else {
                        this.errors.email = '';
                    }
                }).catch(error => {
                    // Handle errors here
                    if (error.response?.data?.message != null) {
                        this.errors.email = error.response.data.message;
                    }
                });
            this.errors.email = '';
        },
        searchOptions(search_name) {
            if(search_name != '') {
                //Only look if they have searched for something
                this.searching = true;
                this.search_error = false;
                window.axios.post('/api/client/api_lookup', {name: search_name})
                    .then(response => {
                        this.local_org_list = [];
                        if(response.data.results != null) {
                            for(let i = 0; i < response.data.results.length; i++) {
                                let label = response.data.results[i].name;
                                if(response.data.results[i].address != null && response.data.results[i].address.city != null)
                                    label += " - " + response.data.results[i].address.city + ", " + response.data.results[i].address.state;

                                this.local_org_list.push({
                                    ein: response.data.results[i].ein,
                                    revenue: response.data.results[i].revenues_total.value,
                                    ntee: response.data.results[i].ntee.value,
                                    label: label,
                                    name: response.data.results[i].name
                                });
                            }
                        }
                        this.searching = false;
                    }).catch(error => {
                        this.searching = false;
                        this.local_org_list = [];
                        this.search_error = true;
                    });
            }
        },
        selectOrg(org_selected) {
            this.searched_org = true;
            if(org_selected == null) {
                this.resetOrg();
                return;
            }
            this.local_org.name = org_selected.name;
            this.errors.name = '';
            this.checkOrganization();
            this.local_org.ein = org_selected.ein;

            // Close Bootstrap dropdown
            const toggle = this.$el.querySelector('.client-select-toggle');
            let dropdownInstance = null;
            if (toggle) {
                if (window && window.bootstrap && window.bootstrap.Dropdown) {
                    dropdownInstance = window.bootstrap.Dropdown.getInstance(toggle) || new window.bootstrap.Dropdown(toggle);
                } else if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                    dropdownInstance = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle);
                }
                if (dropdownInstance && typeof dropdownInstance.hide === 'function') {
                    dropdownInstance.hide();
                }
            }
            this.isOrgDropdownOpen = false;
            this.orgSearchKey = '';

            if(org_selected.revenue != null) {
                if(org_selected.revenue < 1000000)
                    this.local_org.size = "Less than $1M";
                else if(org_selected.revenue < 5000000)
                    this.local_org.size = "$1M-$5M";
                else if(org_selected.revenue < 10000000)
                    this.local_org.size = "$5M-$10M";
                else if(org_selected.revenue < 25000000)
                    this.local_org.size = "$10M-$25M";
                else if(org_selected.revenue < 50000000)
                    this.local_org.size = "$25M-$50M";
                else 
                    this.local_org.size = "$50M+";
            }

            if(org_selected.ntee) {
                //If it starts with A
                if(org_selected.ntee[0] == 'A')
                    this.local_org.vertical = 'Arts, Culture, and Humanities';
                else if(org_selected.ntee[0] == 'B')
                    this.local_org.vertical = 'Education';
                else if(org_selected.ntee[0] == 'C')
                    this.local_org.vertical = 'Environment';
                else if(org_selected.ntee[0] == 'D')
                    this.local_org.vertical = 'Animal-Related';
                else if(org_selected.ntee[0] == 'E' || org_selected.ntee[0] == 'F' || org_selected.ntee[0] == 'G'||org_selected.ntee[0] == 'H' || org_selected.ntee[0] == 'M' || org_selected.ntee[0] == 'P' || org_selected.ntee[0] == 'K')
                    this.local_org.vertical = "Health & Human Services";
                else if(org_selected.ntee[0] == 'Q' || org_selected.ntee[0] == 'R'|| org_selected.ntee[0] == 'V')
                    this.local_org.vertical = "Public Policy/Advocacy";
                else if(org_selected.ntee[0] == 'X')
                    this.local_org.vertical = 'Religion';
                else
                    this.local_org.vertical = 'General Nonprofit';
            }

            window.axios.post('/api/client/api_lookup', {ein: this.local_org.ein})
                .then(response => {
                    if(response.data) {
                        if(response.data.website_url != null && response.data.website_url != "") {
                            const url = new URL(response.data.website_url);
                            let host = url.hostname;
                            //Remove www if it is at the start
                            if(host.startsWith("www."))
                                host = host.substring(4);
                            this.local_org.domain = host;
                        } else {
                            this.local_org.domain = "";
                            this.searched_org = false;
                        }
                        this.local_org.mission = response.data.description;
                        this.local_org.systems = response.data.widget_types;
                        if(response.data.fiscal_year_end != null && response.data.fiscal_year_end != '')
                            this.local_org.fiscal_year_offset = this.getFiscalYearStart(response.data.fiscal_year_end);
                        else 
                            this.searched_org = false;

                        this.processing = false;
                    }
                }).catch(error => {
                    this.searched_org = false;
                    this.processing = false;
                    this.local_org_list = [];
                });
        },
        addNewOrg(search) {
            this.searched_org = false;
            this.local_org.ein = null;
            this.local_org.name = search;
            this.local_org.size = null;
            this.local_org.fiscal_year_offset = 0;
            this.local_org.vertical = null;

            this.checkOrganization();

            // Close Bootstrap dropdown
            const toggle = this.$el.querySelector('.client-select-toggle');
            let dropdownInstance = null;
            if (toggle) {
                if (window && window.bootstrap && window.bootstrap.Dropdown) {
                    dropdownInstance = window.bootstrap.Dropdown.getInstance(toggle) || new window.bootstrap.Dropdown(toggle);
                } else if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                    dropdownInstance = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle);
                }
                if (dropdownInstance && typeof dropdownInstance.hide === 'function') {
                    dropdownInstance.hide();
                }
            }
            this.isOrgDropdownOpen = false;
            this.orgSearchKey = '';
            this.errors.name = '';
        },
        selectFirstVisibleOrg() {
            if (this.local_org_list && this.local_org_list.length > 0) {
                this.selectOrg(this.local_org_list[0]);
                // Close dropdown
                const toggle = this.$el.querySelector('.client-select-toggle');
                let dropdownInstance = null;
                if (toggle) {
                    if (window && window.bootstrap && window.bootstrap.Dropdown) {
                        dropdownInstance = window.bootstrap.Dropdown.getInstance(toggle) || new window.bootstrap.Dropdown(toggle);
                    } else if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                        dropdownInstance = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle);
                    }
                    if (dropdownInstance && typeof dropdownInstance.hide === 'function') {
                        dropdownInstance.hide();
                    }
                }
                this.isOrgDropdownOpen = false;
                this.orgSearchKey = '';
            } else if (this.orgSearchKey && this.orgSearchKey.trim() !== '') {
                this.addNewOrg(this.orgSearchKey.trim());
            }
        },
        checkOrganization() {
            this.errors.name = '';

            if(this.local_org.name != null && this.local_org.name != '')
                window.axios.post('/api/register/organization_exists', {
                    name: this.local_org.name,
                    ein: this.local_org.ein
                }).then(response => {
                    // Handle success if needed
                }).catch(error => {
                    if (error.response?.status === 422) {
                        this.errors.name = error.response.data.message;
                    }
                });
        },
        createAccount() {
            if(this.hasErrors()) {
                return;
            }
            this.processing = true;

            //Get the hubspotutk cookie
            this.local_user.hubspotutk = this.getCookieValue('hubspotutk');
            this.local_user.page_url = window.location.href;
            this.local_user.page_name = document.title;

            const data = {
                user: this.local_user,
                organization: this.local_org,
                api_registration_form_source: 'Wiland',
            }

            window.axios.post('/api/register', data)
                .then(response => {
                    this.processing = false;
                    //Redirect to the Wiland benchmark page with the client URL
                    const client = response.data.client;
                    if (client && client.url) {
                        window.location.href = `/benchmarks/demo/dashboard`;
                    } else {
                        window.location.href = '/';
                    }
                }).catch(error => {
                    // Handle errors here
                    if (error.response?.status === 422) {
                        this.form.error = true;
                        this.errors.email = 'The email entered is not in the correct format.';
                    }
                    // Handle errors here
                    else if (error.response?.status === 412) {
                        this.errors.email = 'The email entered is already attached to an existing user. <a href="/login">Click here to login.</a>';
                    }
                    this.processing = false;
                });
        },
        getCookieValue(cookieName) {
            const cookies = document.cookie.split('; ');
            
            for (let i = 0; i < cookies.length; i++) {
                const [name, value] = cookies[i].split('=');
                if (name === cookieName) {
                    return decodeURIComponent(value);
                }
            }
            return null; // Return null if the cookie is not found
        },
        validatePassword() {
            // If password is empty, no need to validate
            if (!this.local_user.password.value) {
                this.errors.password = '';
                return;
            }

            // Validate password complexity using the API
            window.axios.post('/api/user/validate_password', {
                password: this.local_user.password.value
            })
            .then(response => {
                if (!response.data.valid) {
                    this.errors.password = response.data.errors.join(' ');
                } else {
                    this.errors.password = '';
                }
            })
            .catch(error => {
                console.error('Password validation error:', error);
                this.errors.password = 'Error validating password. Please try again.';
            });
        },
        resetOrg() {
            this.local_org = {
                name: '',
                type: 'nonprofit',
                ein: null,
                size: null,
                vertical: null,
                domain: null,
                fiscal_year_offset: 0,
                mission: null
            };
        },
        getFiscalYearStart(fiscalYearEnd) {
            // Implementation of fiscal year start calculation
            // This method was referenced but not implemented in the original code
            return 0; // Placeholder implementation
        },
        setupOrgDropdownBehavior() {
            const toggle = this.$el.querySelector('.client-select-toggle');
            const menu = this.$el.querySelector('#org-search-dropdown-menu');
            if (!toggle || !menu) return;

            let dropdownInstance = null;
            if (window && window.bootstrap && window.bootstrap.Dropdown) {
                dropdownInstance = window.bootstrap.Dropdown.getInstance(toggle) || new window.bootstrap.Dropdown(toggle, { autoClose: true });
            } else if (typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
                dropdownInstance = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle, { autoClose: true });
            }

            // Keep state in sync using Bootstrap events
            toggle.addEventListener('shown.bs.dropdown', () => {
                this.isOrgDropdownOpen = true;
                this.$nextTick(() => this.focusOrgToggleSearch());
            });
            toggle.addEventListener('hidden.bs.dropdown', () => {
                this.isOrgDropdownOpen = false;
                this.orgSearchKey = '';
                this.local_org_list = [];
            });

            // Stop propagation from menu clicks so outside click detection works
            menu.addEventListener('click', (event) => {
                event.stopPropagation();
            });

            // Outside click handling: close if open
            this._outsideClickHandler = (event) => {
                const container = this.$el.querySelector('.client-select-container');
                const isOpen = menu.classList.contains('show');
                if (isOpen && container && !container.contains(event.target)) {
                    if (dropdownInstance && typeof dropdownInstance.hide === 'function') {
                        dropdownInstance.hide();
                    }
                    this.isOrgDropdownOpen = false;
                    this.orgSearchKey = '';
                    this.local_org_list = [];
                }
            };
            document.addEventListener('click', this._outsideClickHandler, true);
        }
    }
});
</script>